<template>
  <div class="animated fadeIn step-container plan-payment-confirmation">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h2 class="text-center">สมัครแพลนการใช้งาน</h2>
      </div>
      <div class="col-md-8 offset-md-2">
        <step :currentStep="3" :maxStep="3" @step_clicked='gotoPage'>
          <div slot='1'>กรอกรายละเอียด</div>
          <div slot='2'>การชำระเงิน</div>
          <div slot='3'>ยืนยัน</div>
        </step>
      </div>
      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">ยืนยัน</h4>
        <div class="row">
          <div class="col-sm-7">
            <table class="table">
              <thead>
                <tr>
                  <th>Detail</th>
                  <th>ระยะเวลา</th>
                  <th>ราคา</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <p>
                      <strong>{{selectedPlan.name}} </strong>
                      <br> 
                      {{selectedPlan.detail}}
                    </p>
                  </td>
                  <td>{{selectedPlan.duration}}</td>
                  <td>฿{{selectedPlan.price | formatNumber}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>ค่าธรรมเนียม (3.8%)</td>
                  <td>฿{{creditCardFee | formatNumber}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>รวมทั้งหมด</td>
                  <td>฿{{selectedPlan.price + creditCardFee | formatNumber}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-sm-5">
            <div class="">
              <p>{{creditCardDetail.name}}</p>
              <p>{{$guser.user.email}}</p>
              <p>{{$guser.user.patient.phone}}</p>
              <p>{{creditCardDetail.city}}</p>
              <p>{{creditCardDetail.postal_code}}</p>
            </div>
          </div>
        </div>

        <div class="row payment-footer">
          <div class="col-6 form-group text-left">
            <router-link class="btn btn-link btn-lg" :to="backLink + addAppParams"><i class="fa fa-arrow-circle-o-left" aria-hidden="true"></i> {{$t('action_message.back')}}</router-link>
          </div>
          <div class="col-6 form-group text-right">
            <button class="btn btn-store btn-lg" @click="confirm" :disabled="isLoading"><i class="fa fa-spinner fa-spin fa-fw" v-if="isLoading"></i> ยืนยัน <i class="fa fa-angle-right" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>
    </div>
    <sweet-modal icon="success" title="Done" ref="doneModal" overlay-theme="dark" @close="goToSuccessPage()">
      You have been subscribed to Zeekdoc
      <button slot="button" class="btn btn-store btn-lg" @click="closeDoneModal()">Ok</button>
    </sweet-modal>
    <sweet-modal icon="error" title="Something went wrong" ref="errorModal" overlay-theme="dark">
      Something went wrong with your payment, please contact admin (027156633)
      <button slot="button" class="btn btn-store btn-lg" @click="closeErrorModal()">Ok</button>
    </sweet-modal>
  </div>
</template>

<script>
import Step from '@/components/StepBar'
import { SweetModal } from 'sweet-modal-vue'

export default {
  components: {
    Step,
    SweetModal
  },
  computed: {
    backLink () {
      return '/package/payment/step2?plan_id=' + this.selectedPlan.id
    },
    addAppParams () {
      if (this.$route.query.app !== null && this.$route.query.app !== undefined) {
        return '&app=' + this.$route.query.app
      }
      return ''
    },
    creditCardFee () {
      if (typeof this.selectedPlan.price === 'undefined') {
        return 0
      }
      return parseInt(this.selectedPlan.price * 0.038)
    }
  },
  data () {
    return {
      isLoading: false,
      creditCardDetail: {},
      selectedPlan: {},
      paymentToken: '',
      plans: [
        {
          id: 1,
          name: 'Basic Plan (subscription)',
          detail: '499 (per month) x 3 months',
          duration: '3 เดือน',
          price: 1497
        },
        {
          id: 2,
          name: 'Advance Plan (subscription)',
          detail: '฿399 (per month) x 12 months',
          duration: '1 ปี',
          price: 4788
        },
        {
          id: 3,
          name: 'Pro Plan (subscription)',
          detail: '฿299 (per month) x 36 months',
          duration: '3 ปี',
          price: 10764
        }
      ]
    }
  },
  methods: {
    closeDoneModal () {
      this.$refs.doneModal.close()
    },
    closeErrorModal () {
      this.$refs.errorModal.close()
    },
    goToSuccessPage () {
      window.location.href = '/package/me?callbackPayment=success' + this.addAppParams
    },
    gotoPage (step) {
      this.$router.push({path: `/package/payment/step${step + 1}?plan_id=${this.selectedPlan.id}${this.addAppParams}`})
    },
    confirm () {
      this.isLoading = true
      this.$http.post(this.$APP_CONFIG.api.admin.subscription(), {
        plan_id: this.selectedPlan.id,
        token_id: this.paymentToken,
        amount: parseInt(this.selectedPlan.price + this.creditCardFee)
      })
      .then(result => {
        this.$refs.doneModal.open()
      })
      .catch(error => {
        console.log(error)
        this.isLoading = false
        this.$refs.errorModal.open()
      })
    }
  },
  mounted () {
    if (this.$route.query.plan_id &&
    this.$route.query.plan_id > 0 &&
    this.$route.query.plan_id <= 3) {
      this.selectedPlan = this.plans[parseInt(this.$route.query.plan_id) - 1]
    } else {
      this.selectedPlan = this.plans[0]
    }
    // Get credit card detail and payment token object from localstorage
    this.creditCardDetail = Object.assign({}, this.$ls.get('creditCardDetail'))
    this.paymentToken = this.$ls.get('paymentToken')

    // Go back to payment detail if the card detail is not available in the localstorage
    if (typeof this.creditCardDetail.name === 'undefined' || this.paymentToken.length <= 1) {
      this.$router.push({path: '/package/payment/step2?plan_id=' + this.selectedPlan.id})
    }
  }
}
</script>

<style lang='scss'>
@import "../../../assets/base_container";
.plan-payment-confirmation{
  table{
    border: 1px #cfd8dc solid;
  }
}
.step-body{
  background-color: #fff;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// step3.vue?731f5eb3